import { IEntity } from '@pf/shared-common';
import {
    ContactFragment,
    PackingListFragment,
    ProjectLineItemFragment,
    ProjectPriority,
    ProjectSearchRequestParams,
    ProjectStatus,
    ProjectTypeFragment,
    ProjectViewModelCreateBody,
    ProjectViewModelRead,
    ResourceAuth,
    WarehouseFragment,
} from '@control-tower/platform-wms';
import { CustomFieldDto, ILocationFragmentDto } from '@pf/shared/util-platform';
import { IWarehouseEntity } from '../interfaces/warehouse-entity';

export type ProjectRead = ProjectViewModelRead & IEntity;
export type ProjectCreate = ProjectViewModelCreateBody;
export type ProjectSearchParams = ProjectSearchRequestParams;

export class ProjectDto implements IWarehouseEntity {
    constructor(data: Partial<ProjectDto>) {
        Object.assign(this, data);
    }
    id!: string;
    number!: string;
    status!: ProjectStatus;
    priority!: ProjectPriority;
    warehouse!: WarehouseFragment;

    notes?: string | null;
    assignedTo?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    externalReferenceId?: string | null;
    primaryLocation?: ILocationFragmentDto;
    secondaryLocation?: ILocationFragmentDto;
    requestingContact?: ContactFragment;
    projectType?: ProjectTypeFragment;
    lineItems?: Array<ProjectLineItemFragment> | null;
    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;
    customFields?: CustomFieldDto[];
    packingLists?: Array<PackingListFragment> | null;
    resourceAuth?: ResourceAuth;
}
